import { registerAction } from '../../Action'

const SERVICES_LOADED = 'SERVICES_LOADED'

const reducer = (state = {}) => ({
  ...state,
  servicesLoaded: true,
})

const servicesLoaded = registerAction(SERVICES_LOADED, { reducer })

export default servicesLoaded
